import { render } from "./Wishboard.vue?vue&type=template&id=7d15bee1&scoped=true"
import script from "./Wishboard.vue?vue&type=script&lang=js"
export * from "./Wishboard.vue?vue&type=script&lang=js"

import "./Wishboard.vue?vue&type=style&index=0&id=7d15bee1&lang=css"
import "./Wishboard.vue?vue&type=style&index=1&id=7d15bee1&scoped=true&lang=css"
/* custom blocks */
import block0 from "./Wishboard.vue?vue&type=custom&index=0&blockType=div&style=position%3A%20fixed%3B%20bottom%3A%200%3B%20width%3A%20100%25%3B%20background-color%3A%20%23f8f9fa%3B%20padding%3A%2010px%3B%20text-align%3A%20center%3B%20font-size%3A%2012px%3B%20color%3A%20%236c757d%3B"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d15bee1"]])

export default __exports__